import { defineTool } from '@/shell/tool';

/** Account Management Agent (Flutter `/agents/account-management`). */
export default defineTool({
  id: 'account-management-agent',
  title: 'Account Management Agent',
  summary:
    'The agent that works an account: its plan, its invoices and its people.',
  section: 'agents',
  order: 20,
  icon: 'account_circle',
  owner: '@Drabu',
  permission: 'account-management-agent:use',
  routes: () => import('./AccountManagementAgentPage'),
});
